import React from 'react';
import { Link } from 'react-router-dom';

export const HomeNavbar = () => (
  <header
    className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-black/[0.06]"
    data-testid="home-navbar"
  >
    <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
      <Link to="/" className="text-2xl font-bold tracking-tight" data-testid="home-logo">
        <span className="text-[#0F0F0F]">Vy</span>
        <span className="text-[#FF451A]">vre</span>
      </Link>
      <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-[#0F0F0F]">
        <a href="#for-brands" className="hover:text-[#FF451A] transition-colors" data-testid="nav-for-brands">
          For Brands
        </a>
        <a href="#for-agencies" className="hover:text-[#FF451A] transition-colors" data-testid="nav-for-agencies">
          For Agencies
        </a>
      </nav>
      <div className="flex items-center gap-2 md:gap-3">
        <Link
          to="/login"
          className="px-4 py-2 rounded-full text-sm font-semibold border border-black/10 text-[#0F0F0F] hover:bg-black/[0.03] transition-colors"
          data-testid="navbar-sign-in"
        >
          Sign In
        </Link>
        <Link
          to="/demo"
          className="px-4 py-2 rounded-full text-sm font-semibold bg-[#FF451A] text-white hover:bg-[#E63E17] transition-colors shadow-[0_4px_20px_rgba(255,69,26,0.25)]"
          data-testid="navbar-request-demo"
        >
          Request Demo
        </Link>
      </div>
    </div>
  </header>
);

export default HomeNavbar;
